function initializeSlider() {
  $(".outerImage").each(function () {
    let slideIndex = 1;
    let slides = $(this).find(".product-image");
    showSlides(slideIndex);

    let prevBtn = $(this).find(".prev");
    let nextBtn = $(this).find(".next");

    prevBtn.on("click", function () {
      moveSlider(-1);
    });

    nextBtn.on("click", function () {
      moveSlider(1);
    });

    function moveSlider(n) {
      showSlides((slideIndex += n));
    }

    function showSlides(n) {
      if (n > slides.length) {
        slideIndex = 1;
      }
      if (n < 1) {
        slideIndex = slides.length;
      }
      slides.hide();
      slides.eq(slideIndex - 1).show();
    }
  });

  // 
  $(".quick-view-text").click(function () {
    $(".modal").show();
    $("body").addClass("modal-open");
    $(".modal-backdrop").addClass("show");
    var get_html = $(this)
      .parents(".product-card")
      .find(".custom_swatches-inner.active .quick-view")
      .html();
    $(".modal").html("");
    $(".modal").html(get_html);

    attachSlider(); // Attach hover and click events
    initializeSlider(); // Initialize the slider


    $(".modal-header .close").click(function () {
      $("body").removeClass("modal-open");
      $(".modal").html("");
      $(".modal").hide();
    });
  });

  // 
    $(".custom-swatches-outer").each(function () {
    let swatchIndex = 0;
    let swatches = $(this).find(".custom_swatches-inner");
    let totalSwatches = swatches.length;

    let prevBtn = $(this).find(".prev-bottom");
    let nextBtn = $(this).find(".next-bottom");

    // Hide arrows if there are less than or equal to 4 swatches
    if (totalSwatches <= 4) {
      prevBtn.hide();
      nextBtn.hide();
    } else {
      prevBtn.show();
      nextBtn.show();
    }

    showSwatches(swatchIndex);

    prevBtn.on("click", function () {
      moveSwatches(-1);
    });

    nextBtn.on("click", function () {
      moveSwatches(1);
    });

    function moveSwatches(n) {
      swatchIndex += n;
      if (swatchIndex >= totalSwatches) {
        swatchIndex = 0; // Loop back to the first set of swatches
      } else if (swatchIndex < 0) {
        swatchIndex = totalSwatches - 1; // Loop back to the last set of swatches
      }
      showSwatches(swatchIndex);
      updateButtons();
    }

    function showSwatches(n) {
      swatches.hide();
      for (let i = 0; i < 4; i++) {
        let index = (n + i) % totalSwatches;
        swatches.eq(index).show();
      }
    }

    function updateButtons() {
      if (swatchIndex <= 0) {
        prevBtn.prop("disabled", true).addClass("disabled");
        nextBtn.prop("disabled", false).removeClass("disabled");
      } else if (swatchIndex >= totalSwatches - 4) {
        prevBtn.prop("disabled", false).removeClass("disabled");
        nextBtn.prop("disabled", true).addClass("disabled");
      } else {
        prevBtn.prop("disabled", false).removeClass("disabled");
        nextBtn.prop("disabled", false).removeClass("disabled");
      }
    }
  });
  // 
  let selectedVariants_2 = []; // Declare an array to store the selected variant IDs

  $('.modal-pro-variant span').click(function(){
      const variantId = $(this).attr("value");
    // alert(variantId)
      // Add 'active' class to the clicked span
     $('.modal-pro-variant span').removeClass("active");
      $(this).addClass("active");

      // Push the variant ID into the array
      selectedVariants_2.push(variantId);

      // Now you can use selectedVariants array for comparison
      if (selectedVariants_2.length === 1) {
        var id = $(this).parents('.modal-body-quickView').find(".variant--value[var-title='" + variantId + "']").attr(
          "variant-id"
        );
      } else {
        var selesct_option = selectedVariants_2.join(" / ");
        var id = $(this).parents('.modal-body-quickView').find(".variant--value[var-title='" + selesct_option + "']").attr(
          "variant-id"
        );
      }

      $(this).parents('.modal-body-quickView').find(".add-to-cart-actions-wrapper").attr("add-to-cart-id", id);
    
  });
  //
}

function attachSlider() {
  $(".custom_swatches-inner").hover(function () {
     var data_url = $(this).attr('data-url');
    var data_title = $(this).attr('data-title');
     var data_price = $(this).attr('data-price');
    $(this).parents('.product-card').find('.product-title span').text(data_title);
     $(this).parents('.product-card').find('sale-price').text(data_price);
      $(this).parents('.product-card').find('.product-title ').attr("href", data_url);
    var data_url = $(this).attr("data-url");
    $(this)
      .parents(".product-card__figure")
      .find(".product-card__media")
      .attr("href", data_url);
    $(this).parents(".custom-swatches").find(".get_var_id").hide();
    var image = $(this).find(".get_image_inner").html();
    $(this)
      .parents(".product-card__figure")
      .find(".get_image_inner-top")
      .html("");
    $(this)
      .parents(".product-card__figure")
      .find(".get_image_inner-top")
      .html(image);
    $(".outerImage").each(function () {
      let slideIndex = 1;
      let slides = $(this).find(".product-image");
      showSlides(slideIndex);

      let prevBtn = $(this).find(".prev");
      let nextBtn = $(this).find(".next");

      prevBtn.on("click", function () {
        moveSlider(-1);
      });

      nextBtn.on("click", function () {
        moveSlider(1);
      });

      function moveSlider(n) {
        showSlides((slideIndex += n));
      }

      function showSlides(n) {
        if (n > slides.length) {
          slideIndex = 1;
        }
        if (n < 1) {
          slideIndex = slides.length;
        }
        slides.hide();
        slides.eq(slideIndex - 1).show();
      }
    });
    //
let selectedVariants_2 = []; // Declare an array to store the selected variant IDs

  $('.modal-pro-variant span').click(function(){
      const variantId = $(this).attr("value");
    // alert(variantId)
      // Add 'active' class to the clicked span
     $('.modal-pro-variant span').removeClass("active");
      $(this).addClass("active");

      // Push the variant ID into the array
      selectedVariants_2.push(variantId);

      // Now you can use selectedVariants array for comparison
      if (selectedVariants_2.length === 1) {
        var id = $(this).parents('.modal-body-quickView').find(".variant--value[var-title='" + variantId + "']").attr(
          "variant-id"
        );
      } else {
        var selesct_option = selectedVariants_2.join(" / ");
        var id = $(this).parents('.modal-body-quickView').find(".variant--value[var-title='" + selesct_option + "']").attr(
          "variant-id"
        );
      }

      $(this).parents('.modal-body-quickView').find(".add-to-cart-actions-wrapper").attr("add-to-cart-id", id);
    
  });
  //
    $(".quick-view-text").click(function () {
    $(".modal").show();
    $("body").addClass("modal-open");
    $(".modal-backdrop").addClass("show");
    var get_html = $(this)
      .parents(".product-card")
      .find(".custom_swatches-inner.active .quick-view")
      .html();
    $(".modal").html("");
    $(".modal").html(get_html);

    attachSlider(); // Attach hover and click events
    initializeSlider(); // Initialize the slider


    $(".modal-header .close").click(function () {
      $("body").removeClass("modal-open");
      $(".modal").html("");
      $(".modal").hide();
    });
  });
    //
  });
  
$('.option-2 span').click(function(){
  $('.option-2 span').css('border','none'); // Remove border from all spans
  $(this).css('border','1px solid black'); // Apply border to the clicked span
});
  $('.option-1 span').click(function(){
  $('.option-1 span').css('border','none'); // Remove border from all spans
  $(this).css('border','1px solid black'); // Apply border to the clicked span
});

  
  $(".custom_swatches-inner").click(function () {
    var data_title = $(this).attr('data-title');
    $(this).parents('.product-card').find('.product-title span').text(data_title);
    $(this).parents().find(".custom_swatches-inner").removeClass("active");
    $(this).addClass("active");
    var get_html = $(this).find(".hidden.quick-view").html();
    console.log(get_html);
    $(".modal").html("");
    $(".modal").html(get_html);
    var data_url = $(this).attr("data-url");
    $(this).parents(".product-card__figure a").attr("href", data_url);
    $(this).find(".get_var_id").hide();
    var image = $(this).find(".get_image_inner").html();
    $(this)
      .parents(".product-card__figure")
      .find(".get_image_inner-top")
      .html("");
    $(this)
      .parents(".product-card__figure")
      .find(".get_image_inner-top")
      .html(image);
    $(".outerImage").each(function () {
      let slideIndex = 1;
      let slides = $(this).find(".product-image");
      showSlides(slideIndex);

      let prevBtn = $(this).find(".prev");
      let nextBtn = $(this).find(".next");

      prevBtn.on("click", function () {
        moveSlider(-1);
      });

      nextBtn.on("click", function () {
        moveSlider(1);
      });

      function moveSlider(n) {
        showSlides((slideIndex += n));
      }

      function showSlides(n) {
        if (n > slides.length) {
          slideIndex = 1;
        }
        if (n < 1) {
          slideIndex = slides.length;
        }
        slides.hide();
        slides.eq(slideIndex - 1).show();
      }
    });

    // 
    let selectedVariants_3 = []; // Declare an array to store the selected variant IDs

  $('.modal-pro-variant span').click(function(){
      const variantId = $(this).attr("value");
    // alert(variantId)
      // Add 'active' class to the clicked span
     $('.modal-pro-variant span').removeClass("active");
      $(this).addClass("active");

      // Push the variant ID into the array
      selectedVariants_3.push(variantId);

      // Now you can use selectedVariants array for comparison
      if (selectedVariants_3.length === 1) {
        var id = $(this).parents('.modal-body-quickView').find(".variant--value[var-title='" + variantId + "']").attr(
          "variant-id"
        );
      } else {
        var selesct_option = selectedVariants_3.join(" / ");
        var id = $(this).parents('.modal-body-quickView').find(".variant--value[var-title='" + selesct_option + "']").attr(
          "variant-id"
        );
      }

      $(this).parents('.modal-body-quickView').find(".add-to-cart-actions-wrapper").attr("add-to-cart-id", id);
    
  });
  //
  });
  //

}
$(document).ready(function () {
  // Check for the specific section at intervals
  let checkSectionInterval = setInterval(function () {
    if ($(".custom_swatches-inner").length > 0) {
      clearInterval(checkSectionInterval); // Stop the interval once the section is found
      attachSlider(); // Attach hover and click events
      initializeSlider(); // Initialize the slider
    }
  }, 1000); // Check every second
});

$(document).ready(function () {
  function addToCart(variantId, quantity) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        quantity: quantity,
        id: variantId,
      },
      success: function () {
        $("body").removeClass("modal-open");
        $(".modal").html("");
        $(".modal").hide();

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true, //this code is for prestige theme, is to refresh the cart
          })
        );
        $("#cart-drawer").show();
        $("#cart-drawer").attr("open", true);
        $(".drawer::part(content)").css({
          "margin-inline-start": "auto",
          transform: "translateX(0px)",
        });

        // window.location.href= "/cart"
      },
      error: function (xhr, textStatus, errorThrown) {
        console.error("Error adding product to cart: " + textStatus);
        alert("Not available, Please select another one");
      },
    });
  }

  // Usage example
  $(document).on("click", ".get_var_id span", function () {
    var variantId = $(this).attr("variant-id");
    var quantity = 1; // You can adjust the quantity as needed
    addToCart(variantId, quantity);
  });
});

// recom - relate

// $(document).ready(function () {
//   // Check for the specific section at intervals
//   let checkSectionInterval = setInterval(function () {
//     if ($(".outerImage").length > 0) {
//       clearInterval(checkSectionInterval); // Stop the interval once the section is found
//       initializeSlider(); // Initialize the slider
//     }
//   }, 1000); // Check every second
// });

//
function addToCart(variantId, quantity) {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      quantity: quantity,
      id: variantId,
    },
    success: function () {
      $("body").removeClass("modal-open");
      $(".modal").html("");
      $(".modal").hide();

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true, //this code is for prestige theme, is to refresh the cart
        })
      );
      $("#cart-drawer").show();
      $("#cart-drawer").attr("open", true)
    },
    error: function (xhr, textStatus, errorThrown) {
      console.error("Error adding product to cart: " + textStatus);
      alert("Not available, Please select another one");
    },
  });
}

// Usage example
// $(document).on("click", ".modal-pro-variant span", function () {
//   $(this).addClass("active");
//   var variantId = $(this).attr("variant-id");
//   $(".add-to-cart-actions-wrapper").attr("add-to-cart-id", variantId);
// });

$(document).on("click", ".add-to-cart-actions-wrapper", function () {
  var variantId = $(this).attr("add-to-cart-id");
  var quantity = 1; // You can adjust the quantity as needed
  addToCart(variantId, quantity);
});

//
// $(document).ready(function () {
//   $(".tab").click(function () {
//     $(".tab").removeClass("active");
//     $(this).addClass("active");
//     var section = $(this).data("section");
//     $(".section").addClass("hidden");
//     $("." + section).removeClass("hidden");
//   });
// });

$(document).ready(function () {
  $(".quick-view-text").click(function () {
    $(".modal").show();
    $("body").addClass("modal-open");
    $(".modal-backdrop").addClass("show");
    var get_html = $(this)
      .parents(".product-card")
      .find(".custom_swatches-inner.active .quick-view")
      .html();
    $(".modal").html("");
    $(".modal").html(get_html);

    attachSlider(); // Attach hover and click events
    initializeSlider(); // Initialize the slider


    $(".modal-header .close").click(function () {
      $("body").removeClass("modal-open");
      $(".modal").html("");
      $(".modal").hide();
    });
  });
});
//

$(document).ready(function () {
  $(".custom-swatches-outer").each(function () {
    let swatchIndex = 0;
    let swatches = $(this).find(".custom_swatches-inner");
    let totalSwatches = swatches.length;

    let prevBtn = $(this).find(".prev-bottom");
    let nextBtn = $(this).find(".next-bottom");

    // Hide arrows if there are less than or equal to 4 swatches
    if (totalSwatches <= 4) {
      prevBtn.hide();
      nextBtn.hide();
    } else {
      prevBtn.show();
      nextBtn.show();
    }

    showSwatches(swatchIndex);

    prevBtn.on("click", function () {
      moveSwatches(-1);
    });

    nextBtn.on("click", function () {
      moveSwatches(1);
    });

    function moveSwatches(n) {
      swatchIndex += n;
      if (swatchIndex >= totalSwatches) {
        swatchIndex = 0; // Loop back to the first set of swatches
      } else if (swatchIndex < 0) {
        swatchIndex = totalSwatches - 1; // Loop back to the last set of swatches
      }
      showSwatches(swatchIndex);
      updateButtons();
    }

    function showSwatches(n) {
      swatches.hide();
      for (let i = 0; i < 4; i++) {
        let index = (n + i) % totalSwatches;
        swatches.eq(index).show();
      }
    }

    function updateButtons() {
      if (swatchIndex <= 0) {
        prevBtn.prop("disabled", true).addClass("disabled");
        nextBtn.prop("disabled", false).removeClass("disabled");
      } else if (swatchIndex >= totalSwatches - 4) {
        prevBtn.prop("disabled", false).removeClass("disabled");
        nextBtn.prop("disabled", true).addClass("disabled");
      } else {
        prevBtn.prop("disabled", false).removeClass("disabled");
        nextBtn.prop("disabled", false).removeClass("disabled");
      }
    }
  });

  //
  let selectedVariants = []; // Declare an array to store the selected variant IDs

  $(document).on("click", ".modal-pro-variant span", function () {
      const variantId = $(this).attr("value");

     $('.modal-pro-variant span').removeClass('active')
      $(this).addClass("active");

      // Push the variant ID into the array
      selectedVariants.push(variantId);

      // Now you can use selectedVariants array for comparison
      if (selectedVariants.length === 1) {
        var id = $(this).parents('.modal-body-quickView').find(".variant--value[var-title='" + variantId + "']").attr(
          "variant-id"
        );
      } else {
        var selesct_option = selectedVariants.join(" / ");
        var id = $(this).parents('.modal-body-quickView').find(".variant--value[var-title='" + selesct_option + "']").attr(
          "variant-id"
        );
      }

      $(this).parents('.modal-body-quickView').find(".add-to-cart-actions-wrapper").attr("add-to-cart-id", id);
    
  });
});
